import type { ReactNode } from 'react'

type Option = { value: number; node: ReactNode; selectedClass?: string }

type Props = {
  label: string
  options: Option[]
  selected: number[]
  onToggle: (value: number) => void
}

export default function RatingFilterRow({ label, options, selected, onToggle }: Props) {
  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <div className="flex flex-nowrap gap-2 overflow-x-auto py-2 -my-1 -mx-1 px-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onToggle(opt.value)}
            className={`flex items-center gap-0.5 shrink-0 px-3 py-1.5 rounded-full border transition-colors min-h-[36px] ${
              selected.includes(opt.value)
                ? (opt.selectedClass ?? 'border-primary bg-primary/10')
                : 'border-border bg-background'
            }`}
          >
            {opt.node}
          </button>
        ))}
      </div>
    </div>
  )
}
